import React, { useState } from "react";
import { Plus, Minus, MapPin, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import img64 from "../../../assets/img64.jpg";
import img65 from "../../../assets/img65.jpg";
import img66 from "../../../assets/img66.jpg";
import img67 from "../../../assets/img67.jpg";
import img68 from "../../../assets/img68.png";
import img69 from "../../../assets/img69.jpg";
import img70 from "../../../assets/img70.jpg";
import img71 from "../../../assets/img71.jpg";
import img102 from "../../../assets/Img102.jpg";
import img103 from "../../../assets/Img103.jpg";


const benefits = [
  {
    title: "Apprentissage et développement continus - Croissance et succès",
    content:
      "Nous investissons dans votre développement professionnel grâce à des sessions de formation régulières, des ateliers et des cours. Restez à l'avant-garde des tendances du secteur et améliorez continuellement vos compétences avec nous.",
  },
  {
    title: "Commissions illimitées",
    content:
      "Il n'y a aucune limite à ce que vous pouvez gagner. Avec notre modèle de commissions illimitées, votre potentiel de revenus augmente à mesure que vous élargissez votre clientèle et concluez plus de contrats.",
  },
  {
    title: "Base de clients étendue",
    content:
      "einsured.ca dispose d'une base de clients large et diversifiée, vous offrant de nombreuses opportunités pour développer votre portefeuille. Notre solide réputation sur le marché facilite l'établissement de la confiance et de relations durables avec les clients.",
  },
  {
    title: "Horaires de travail flexibles",
    content:
      "Nous comprenons l'importance de maintenir un équilibre sain entre vie professionnelle et vie personnelle. Nous offrons des arrangements de travail flexibles qui vous permettent de gérer votre temps efficacement, vous assurant de performer au mieux tant sur le plan professionnel que personnel.",
  },
  {
    title: "Technologie de pointe",
    content:
      "Restez à la pointe grâce à l'accès aux derniers outils et technologies du secteur. Nos systèmes avancés simplifient votre travail, vous permettant de vous concentrer sur ce que vous faites le mieux — aider les clients à sécuriser leur avenir financier.",
  },
  {
    title: "Partenariats avec les meilleures compagnies d'assurance",
    content:
      "Chez einsured.ca, vous bénéficierez de nos solides partenariats avec des assureurs de premier plan. Cela vous donne accès à une large gamme de produits et solutions, facilitant la réponse aux besoins de vos clients et la conclusion de contrats.",
  },
];

const OurTeam = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* HERO SECTION */}
      <section
        className="relative min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] lg:h-[80vh] flex items-center bg-cover bg-center"
        style={{ backgroundImage: `url(${img64})` }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 w-full container px-4 sm:px-8 md:px-24">
          <div className="max-w-3xl text-white text-center sm:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
              Rencontrez notre équipe
            </h1>
            <p className="text-base sm:text-lg md:text-xl leading-relaxed">
              Votre équipe de confiance chez einsured.ca - Vous guidant vers la sécurité financière et la tranquillité d'esprit
            </p>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE EINSURED */}
      <section
        className="py-16 sm:py-16 px-4 sm:px-6 md:px-24"
        style={{ backgroundColor: "#edf4ff", color: "#3b5180" }}
      >
        <div className="container text-center px-2">
          <h2 className="text-[#49628b] text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            Pourquoi choisir einsured.ca pour votre carrière ?
          </h2>
          <p
            className="text-base sm:text-lg"
            style={{ color: "#5f6f8f" }}
          >
            Chez einsured.ca, nous nous engageons pour votre succès en tant que conseiller en assurance vie et santé. Voici pourquoi rejoindre notre équipe pourrait être le meilleur choix de carrière que vous fassiez :
          </p>
        </div>

        <div className="container mt-12 grid gap-12 md:gap-16 md:grid-cols-2 items-start">
          <div className="bg-white rounded-3xl shadow-sm p-6 sm:p-10 flex justify-center">
            <img
              src={img65}
              alt="Personnage conseiller einsured.ca"
              className="max-h-[400px] w-auto object-contain"
            />
          </div>

          <div className="flex flex-col justify-center">
            <div
              className="border border-[#d7e3ff] rounded-md overflow-hidden"
              style={{ backgroundColor: "#edf4ff" }}
            >
              {benefits.map((item, index) => {
                const isOpen = index === activeIndex;
                return (
                  <div
                    key={item.title}
                    className="border-t border-[#d7e3ff] first:border-t-0"
                  >
                    <button
                      type="button"
                      onClick={() => handleToggle(index)}
                      className="w-full flex items-center justify-between gap-3 sm:gap-4 px-4 sm:px-6 py-3 sm:py-4 text-left"
                    >
                      <span className="font-semibold text-[#49628b] text-sm sm:text-lg pr-4">
                        {item.title}
                      </span>
                      {isOpen ? (
                        <Minus
                          className="w-5 h-5 text-[#49628b] flex-shrink-0"
                          aria-hidden="true"
                        />
                      ) : (
                        <Plus
                          className="w-5 h-5 text-[#49628b] flex-shrink-0"
                          aria-hidden="true"
                        />
                      )}
                    </button>

                    {isOpen && (
                      <div
                        className="px-4 sm:px-6 pb-4 text-sm sm:text-base"
                        style={{ color: "#5f6f8f", backgroundColor: "#edf4ff" }}
                      >
                        {item.content}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="container mt-12 text-center px-2">
          <p className="text-base" style={{ color: "#5f6f8f" }}>
            Nous nous engageons pour votre développement professionnel. Grâce à des programmes de formation continue et d'amélioration des compétences, vous resterez à l'avant-garde des tendances du secteur et améliorerez continuellement votre expertise.
          </p>

        </div>
      </section>

      {/* JOB POSITION */}
<section
  className="py-16 sm:py-20 px-4 sm:px-6 md:px-24"
  style={{ backgroundColor: "#f5f9ff", color: "#3b5180" }}
>
<p
  className="mt-6 text-sm sm:text-base font-medium text-center container"
  style={{ color: "#5f6f8f" }}
>
  Carrières chez einsured.ca
</p>

<h3
  className="mt-2 text-2xl sm:text-3xl font-bold text-center container"
  style={{ color: "#3b5180" }}
>
  Opportunités en vedette
</h3>

  <div className="container grid gap-10 md:grid-cols-2 items-start bg-white rounded-3xl shadow-sm p-6 sm:p-10 lg:p-12 mt-8">
    {/* Left Box */}
    <div
      className="bg-[#f5f7fc] p-6 sm:p-8 rounded-2xl flex flex-col justify-center items-start"
      style={{ color: "#3b5180" }}
    >
      <h3 className="text-2xl font-semibold mb-6 text-black">
        Conseiller en assurance - Vie et santé
      </h3>
      <div className="flex items-center gap-3 bg-[#f1f3f9] px-4 sm:px-5 py-3 rounded-xl w-full sm:w-auto">
        <MapPin className="w-5 h-5 sm:w-7 sm:h-7 text-[#00a2ff]" />
        <p className="font-semibold text-sm sm:text-lg text-[#49628b]">
          Canada
        </p>
      </div>
    </div>

    {/* Right Box */}
    <div className="text-[#49628b]">
      <h4 className="text-xl font-bold mb-3 text-black">
        Aperçu du poste :
      </h4>
      <p className="text-[#5f6f8f] mb-6 text-sm sm:text-base">
        En tant que{" "}
        <span className="font-semibold text-[#20a7df]">
          Conseiller en assurance vie et santé
        </span>
        , vous jouerez un rôle clé en aidant les clients à prendre des décisions éclairées sur leurs besoins en assurance. Vous serez responsable de conseiller sur les produits d'assurance vie et santé, de personnaliser les plans selon les exigences individuelles de chaque client et de fournir un service client exceptionnel. Votre principal objectif est d'aider les clients à protéger leurs proches et à atteindre la sécurité financière.
      </p>

      <h4 className="text-xl font-bold mb-3 text-black">
        Principales responsabilités :
      </h4>
      <ul className="list-disc pl-5 sm:pl-6 text-[#5f6f8f] space-y-2 text-sm sm:text-base">
        <li>
          Consulter les clients pour comprendre leurs besoins et objectifs en matière d'assurance vie et santé
        </li>
        <li>
          Fournir des conseils professionnels sur une gamme de produits d'assurance vie et santé, notamment l'assurance vie, les maladies graves, l'invalidité et la couverture santé
        </li>
        <li>
          Élaborer des plans d'assurance personnalisés adaptés aux besoins spécifiques des clients
        </li>
        <li>
          Maintenir de solides relations avec les clients en offrant un soutien continu et des révisions d'assurance
        </li>
        <li>
          Effectuer des analyses des besoins et des évaluations des risques pour recommander des options de couverture appropriées
        </li>
        <li>
          Se tenir informé des tendances du secteur, des produits d'assurance et des changements réglementaires
        </li>
        <li>
          Aider les clients dans le processus de réclamation, en assurant un traitement efficace de leurs préoccupations
        </li>
        <li>
          Atteindre les objectifs de vente et de performance grâce à la prospection, le réseautage et les références
        </li>
        <li>
          Respecter les normes de conformité et d'éthique dans toutes les interactions avec les clients
        </li>
      </ul>
    </div>
  </div>

  {/* Join Button */}
  <div className="flex justify-center mt-10">
    <a
      href="/fr/notre-equipe"
      className="bg-[#20a7df] hover:bg-[#008ee0] text-white font-semibold px-10 py-3 rounded-lg shadow-md transition w-full sm:w-auto text-center"
    >
      Rejoindre maintenant
    </a>
  </div>
</section>

{/* OUR TEAM CARDS SECTION */}
<section
  className="py-16 sm:py-2 px-4 sm:px-6 md:px-24"
  style={{ backgroundColor: "#f5f9ff" }}
>
  <div className="container">
    <div className="text-center mb-12 px-2">
      <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b]">
        Notre équipe
      </h2>
      <p className="mt-6 font-bold text-[#5f6f8f] text-sm sm:text-base">
        Rencontrez nos professionnels dévoués !
      </p>
    </div>

    {/* Cards grid */}
    <div className="grid gap-10 lg:gap-12 md:grid-cols-2">
      {/* AMAN */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img66}
            alt="Aman Ahuja"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/fr/notre-equipe/aman"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Aman Ahuja
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">
            PDG &amp; Courtier principal en assurance
          </p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14168166100"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 816-6100
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 100
            </a>
            <a
              href="mailto:aman@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>aman@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* SUNAINA */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img67}
            alt="Sunaina Ahuja"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
         <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/fr/notre-equipe/sunaina"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Sunaina Ahuja
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">
            Directrice des opérations (COO) &amp; Courtière d'assurance
          </p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14165649000"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 564-9000
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 101
            </a>
            <a
              href="mailto:sunaina@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>sunaina@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* AARTI */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img68}
            alt="Aarti"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/fr/notre-equipe/aarti"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Aarti
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Courtière d'assurance</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14169901800"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 990-1800
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 104
            </a>
            <a
              href="mailto:acl.13n@gmail.com"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>acl.13n@gmail.com</span>
            </a>
          </div>
        </div>
      </div>

      {/* SHIKHA */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img69}
            alt="Shikha Ahuja"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/fr/notre-equipe/shikha"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Shikha Ahuja
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Courtière d'assurance</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+16475322101"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (647) 532-2101
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 102
            </a>
            <a
              href="mailto:shikha@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>shikha@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* GURKIRAN */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img70}
            alt="Gurkiran Kaur"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/fr/notre-equipe/gurkiran"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Gurkiran Kaur
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Courtière d'assurance</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 103
            </a>
            <a
              href="mailto:gurkiran@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>gurkiran@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* SAMRIDHI */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img71}
            alt="Samridhi Sharma"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/fr/notre-equipe/samridhi"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Samridhi Sharma
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Courtière d'assurance</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+17807778950"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (780) 777-8950
            </a>
            <a
              href="mailto:getinsured.sam@gmail.com"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>getinsured.sam@gmail.com</span>
            </a>
          </div>

        </div>

      </div>
           {/* EKTA */}
            <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
              <div className="flex-shrink-0">
                <img src={img102} alt="Ekta" className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover" loading="lazy" />
              </div>
              <div className="flex-1 text-white">
                <div className="flex justify-center sm:justify-start mb-6">
                  <Link to="/fr/notre-equipe/ekta" className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors">Ekta</Link>
                </div>
                <p className="text-sm sm:text-base mb-4">Courtière d'assurance</p>
                <div className="space-y-3 w-full">
                  <a href="tel:+14162575700" className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full">(416) 257-5700</a>
                  <a href="mailto:insurewithekta@gmail.com" className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"><Mail className="w-4 h-4" /><span>insurewithekta@gmail.com</span></a>
                  </div>
              </div>
            </div>

            {/* YASHRAJ */}
            <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
              <div className="flex-shrink-0">
                <img src={img103} alt="Yashraj Kharbanda" className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover" loading="lazy" />
              </div>
              <div className="flex-1 text-white">
                <div className="flex justify-center sm:justify-start mb-6">
                  <Link to="/fr/notre-equipe/yashraj" className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors">Yashraj Kharbanda</Link>
                </div>
                <p className="text-sm sm:text-base mb-4">Courtier d'assurance</p>
                <div className="space-y-3 w-full">
                  <a href="tel:+16476791829" className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full" >(647) 679-1829</a>
                  <a href="mailto:kharbandayashraj1@gmail.com" className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full" ><Mail className="w-4 h-4" /><span>kharbandayashraj1@gmail.com</span></a>
                </div>
              </div>
            </div>
    </div>
  </div>
</section>

    </>
  );
};

export default OurTeam;
